/**
 * Quiz/Ruler 3232:18886 — a scale that slides under a fixed centre indicator.
 * Horizontal: 10px per unit, ticks every unit, a major tick + label every 5.
 * Vertical (Height): 8px per unit, value grows downwards.
 */
export type FairQuizRulerOrientation = 'horizontal' | 'vertical'

export const FAIR_QUIZ_RULER_PX: Record<FairQuizRulerOrientation, number> = {
  horizontal: 10,
  vertical: 8,
}

export const FAIR_QUIZ_RULER_MAJOR_EVERY = 5

export function snapFairQuizRuler(value: number, step: number, min: number, max: number): number {
  const snapped = Math.round(value / step) * step
  const clamped = Math.max(min, Math.min(max, snapped))
  // Keep 0.5 steps clean of float noise (24.499999…).
  return Math.round(clamped * 10) / 10
}

/** Drag by `delta` px from `start`: the scale follows the finger, so the value moves the other way. */
export function fairQuizRulerDragValue(
  start: number,
  delta: number,
  px: number,
  step: number,
  min: number,
  max: number,
): number {
  return snapFairQuizRuler(start - delta / px, step, min, max)
}

/** Whole units from min to max; every 5th is major (labelled). */
export function fairQuizRulerTicks(min: number, max: number): { value: number; major: boolean }[] {
  const ticks: { value: number; major: boolean }[] = []
  for (let value = Math.ceil(min); value <= Math.floor(max); value += 1) {
    ticks.push({ value, major: value % FAIR_QUIZ_RULER_MAJOR_EVERY === 0 })
  }
  return ticks
}

/** Untouched rulers rest in the middle of the range; nothing is recorded yet. */
export function fairQuizRulerRest(min: number, max: number, step: number): number {
  return snapFairQuizRuler((min + max) / 2, step, min, max)
}
